export type WorkspaceRole = "owner" | "admin" | "developer" | "viewer";

export const roleDescriptions: Record<WorkspaceRole, string> = {
  viewer: "Can see allowed metadata. No env access, publish, grants, or billing by default.",
  developer: "Regular teammate. Can be assigned projects and granted exact channel access later.",
  admin: "Can manage projects, members, grants, machines, channels, and audit for the workspace.",
  owner: "Full authority for billing, owner management, deletion, and final workspace control."
};

export function canInviteRole(inviterRole: WorkspaceRole, invitedRole: WorkspaceRole) {
  if (inviterRole === "owner") return true;
  if (inviterRole === "admin") return invitedRole !== "owner";
  return false;
}

export function isValidInviteEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
